import { apiGet } from './api';

// Chapter Summary + Slides. Generated once per chapter server-side and cached
// for everyone, so these are plain reads — never "generate" buttons.

const P = '/premium/v1/content';

const scope = (subject, topic) =>
  `?subject=${encodeURIComponent(subject || '')}&topic=${encodeURIComponent(topic || '')}`;

export const fetchChapterSummary = (subject, topic) => apiGet(`${P}/summary${scope(subject, topic)}`);
export const fetchChapterSlides = (subject, topic) => apiGet(`${P}/slides${scope(subject, topic)}`);

export function activeScope() {
  try {
    return {
      subject: window.localStorage.getItem('gv_active_subject') || '',
      topic: window.localStorage.getItem('gv_active_topic') || '',
    };
  } catch { return { subject: '', topic: '' }; }
}
